import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { firePAEvent } from './utils/analytics';
import { contactHref } from './utils/contactContext';

/*
 * Header (31 Aug 2026 rebuild) — the canonical navigation.
 *
 * Three elements only, identical on every page:
 *   Logo        -> home
 *   Contact us  -> /contact, which redirects to the one form on the site
 *   Login       -> the CMPX portal
 *
 * No nav links. The footer is the site map, which keeps the lockup from
 * being crowded out and matches the one-spine-plus-supporting-surfaces
 * shape the board set. Rationale and the audit that led here are in
 * PO - Website/Mockups/Website_Wireframe_System.html, Gap analysis, J.
 *
 * The lockup is the canonical brand asset. Never composite one from the
 * icon plus text — that is a hard rule in the brand book, and the
 * previous header broke it.
 */

const Header = () => {
    const { pathname } = useLocation();
    const handleContact = () => firePAEvent('employer_cta_click', { source: 'header' });
    const handleLogin = () => firePAEvent('outbound_portal', { source: 'header' });

    return (
        <header className="pa-header">
            <nav className="pa-nav">
                <Link to="/" className="pa-brand" aria-label="PhysioActivity home">
                    <img src="/brand/physioactivity-lockup.png" alt="PhysioActivity" className="pa-lockup" />
                </Link>

                <div className="pa-actions">
                    {/* Carries the page the reader is on, so the form opens on the
                        right "I am". This link is on every page, which makes it the
                        single biggest source of context — worth more than any
                        individual page CTA. */}
                    <Link to={contactHref(pathname)} className="pa-contact" onClick={handleContact}>
                        Contact us
                    </Link>
                    <a
                        href="https://portal.physioactivity.com/"
                        className="pa-login"
                        onClick={handleLogin}
                    >
                        Login
                    </a>
                </div>
            </nav>
        </header>
    );
};

export default Header;
